"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * @internal
 * Convert pasted content if there are HTML and Image data in the Clipboard
 * @param event The BeforePaste event
 */
function convertPasteContentForSingleImage(event, trustedHTMLHandler) {
    var fragment = event.fragment, clipboardData = event.clipboardData;
    var html = clipboardData.html, image = clipboardData.image;
    if (html && image) {
        //If there are Html in the clipboard, and the html body only have one img children, use the HTML
        var doc = new DOMParser().parseFromString(trustedHTMLHandler(html), 'text/html');
        roosterjs_editor_dom_1.moveChildNodes(fragment, doc === null || doc === void 0 ? void 0 : doc.body);
    }
}
exports.default = convertPasteContentForSingleImage;
//# sourceMappingURL=convertPasteContentForSingleImage.js.map